'use client';
import { useRef } from 'react';
import { Box, IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

type Props = {
  showArrows: boolean;
  children: React.ReactNode;
};

const SCROLL_AMOUNT = 360;

const ArrowScrollContainer = ({ showArrows, children }: Props) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    scrollRef.current?.scrollBy({
      left: direction === 'left' ? -SCROLL_AMOUNT : SCROLL_AMOUNT,
      behavior: 'smooth',
    });
  };

  const arrowSx = {
    position: 'absolute' as const,
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1,
    bgcolor: 'background.paper',
    boxShadow: 2,
    '&:hover': { bgcolor: 'background.paper' },
  };

  return (
    <Box sx={{ position: 'relative' }}>
      {showArrows && (
        <IconButton
          className={'tb-cards-arrow-left'}
          onClick={() => scroll('left')}
          sx={{ ...arrowSx, left: -20 }}
        >
          <ChevronLeftIcon />
        </IconButton>
      )}
      <Box
        ref={scrollRef}
        className={'tb-cards-inner-container'}
        sx={{
          display: 'flex',
          overflowX: 'auto',
          gap: 2,
          scrollSnapType: 'x mandatory',
          pb: 2,
          '&::-webkit-scrollbar': { height: 6 },
          '&::-webkit-scrollbar-thumb': {
            bgcolor: 'text.disabled',
            borderRadius: 3,
          },
        }}
      >
        {children}
      </Box>
      {showArrows && (
        <IconButton
          className={'tb-cards-arrow-right'}
          onClick={() => scroll('right')}
          sx={{ ...arrowSx, right: -20 }}
        >
          <ChevronRightIcon />
        </IconButton>
      )}
    </Box>
  );
};

export default ArrowScrollContainer;
